<template>
  <div style="position: relative">
    <iframe v-if="this.version!=''" id="baidutongji" name="baidutongji"
        :src="`https://aiplugin.5118.com/Pluginstat/?p=checkrank&v=${version}`"
        style="width: 0px; height: 0px; position: fixed; transform: translateY(-9999px);"></iframe>
    <div dir="rtl" class="page">
      <div dir="ltr">
        <p class="checkdomainname" :title="getdomain">当前域名【{{getdomain}}】</p>
        <div style="margin: 10px 0;position: relative;">
          <input type="text" title="关键词" class="input" @blur="showcheckranklist(2)" @mousedown="showcheckranklist(1)" @ placeholder="请输入关键词" v-model="keyword"
                 @keyup.enter="checkBaiduRank">
          <a href="javascript:" style="position: absolute;right: 7px;top: 6px;" @click="checkBaiduRank">
            <img src="../assets/image/lupita.png" style="width: 16px">
          </a>
        </div>
        <BaiduRankList v-if="checkranklist" v-on:listenTochildEvent="showMessageFromChild" :domain="getdomain"
              v-on:listenToIshow="isshowing"
              style="position: absolute;width: 90.5%;z-index: 1000;background-color: white;margin-top: -7px;">
        </BaiduRankList>
        <table style="width:100%;margin-top: -10px;">
          <tr>
            <td style="width:50%">
              <div>
                <p style="font-size: 12px;color: red;" v-if="isShow">排名大于50</p>
              </div>
            </td>
            <td>
              <div style="margin: 10px 0;text-align: right">

                <button class="btn is-plain" @click="exportList">
                  <img src="../assets/image/export_ico.png" style="vertical-align: middle">
                  导出数据
                </button>

              </div>
            </td>
          </tr>
        </table>


        <table class="baidurank-table" style="table-layout: fixed">
          <thead>
          <tr>
            <th>关键词</th>
            <th>排名位置</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in items" :key="index">
            <td @click="jump_baidu(item.keyword,item.rank)" :title="item.keyword" style="cursor: pointer;">{{item.keyword}}</td>
            <td style="padding-left: 5px;">{{item.rank===50?'>50':item.rank.join(",")}}</td>
          </tr>
          </tbody>
        </table>
        <!-- <p v-if="!items.length&&isShow">
          未发现排名词数据
        </p> -->
      </div>
    </div>
    <div class="div-bottom">
      <button class="btn btn-bottom" onclick="window.open('https://monitor.5118.com/keywords?f=plugin')">关键词排名持续监控</button>
    </div>
  </div>
</template>

<script>
  import {mapActions} from "vuex"
  import BaiduRankList from "../components/BaiduRankList";

  export default {
    name: "BaiduRank",
    data() {
      return {
          checkranklist:false,
          isranklistshowing:false
      }
    },
    mounted() {

      this.ASetHistory("baidurank").then(flag => {
        if (flag) {
          this.listenBaiduRank()
        }
      });
    },
    components: {
     BaiduRankList
    },
    computed: {
      isShow: {
        get() {
          return this.$store.state.baiduRank.isShow
        },
        set(val) {
          this.$store.state.baiduRank.isShow = val
        }
      },
      keyword: {
        get() {
          return this.$store.state.baiduRank.keyword;
        },
        set(val) {
          this.$store.state.baiduRank.keyword = val
        }
      },
      items: {
        get() {
          return this.$store.state.baiduRank.items;
        },
        set(val) {
          this.$store.state.baiduRank.items = val
        }
      },
      version:{
        get(){
          return this.$store.state.menu.version
        },
        set(val){
          this.$store.state.menu.version = val
        }
      },
      getdomain:{
        get(){
          return this.$store.state.menu.jump_domain_url;
        }
      }
    },
    methods: {
      ...mapActions("menu", ["ASetHistory"]),
      checkBaiduRank() {
       this.checkranklist=false;
        this.isShow = false;
        //this.items = [];
        if(this.keyword!="")
        {
          this.$messenger.targets['parent'].send("Check-Searc-BaiduRank", {keyword: this.keyword});

          let savewordslist=[];
          if(localStorage.getItem(this.getdomain+'_baiduranklist'))
          {
            savewordslist=JSON.parse(localStorage.getItem(this.getdomain+'_baiduranklist'));
          }
          for(let i=0;i<savewordslist.length;i++)
          {
            if(savewordslist.length>=15)
            {
              if(i===0)
              {
                 savewordslist.splice(0,1)
              }
            }
            let checkword=savewordslist[i].checkwords;
            if(checkword==this.keyword)
            {
              this.keyword='';
              return
            }
          }
          let keywordsinfo={checkwords:this.keyword};
          savewordslist.push(keywordsinfo);

          localStorage.setItem(this.getdomain+'_baiduranklist',JSON.stringify(savewordslist));
          this.keyword='';
        }

      },
      listenBaiduRank() {
        this.$messenger.listen("_5118_Searc_BaiduRank_Info", (msg) => {
          if (msg && msg.length) {
            for (let item of msg) {
              for (let j of this.$store.state.baiduRank.items) {
                if (j.keyword === item.keyword) {
                  j.rank = item.rank;
                  j.pagenumber = item.pagenumber;
                  return;
                }
              }
              // _hmt.push(['_trackEvent', 'BaiduRank', 'Check']);
              this.$store.state.baiduRank.items.push(item);
              this.items.reverse();
            }
          } else {
            this.isShow = true;
          }
        });

      },
      exportList(){
        this.$messenger.targets['parent'].send("_5118_Export","CheckBaiduRank");
      },
      jump_baidu(keyword,rank){
        let pagenumber=0;
        String(rank).indexOf(',')==-1?rank=String(rank):rank=String(rank).split(',')[0];
        rank>10 && rank<21?pagenumber=10:rank>20 && rank<31?pagenumber=20:rank>30 && rank<41?pagenumber=30:rank>40 && rank<51?pagenumber=40:pagenumber=0
        window.open('https://www.baidu.com/s?pn='+pagenumber+'&wd='+keyword+'&ie=utf-8&usm=1#'+rank)
      },
      showcheckranklist(showtype){
        if(localStorage.getItem(this.getdomain+'_baiduranklist'))
        {
          if(showtype===1)
          {
            this.checkranklist=true
          }
          else
          {
            if(!this.isranklistshowing)this.checkranklist=false
          }
        }
      },
      showMessageFromChild(){
        this.checkranklist=false;
      },
      isshowing(istype){
        if(istype){
          this.isranklistshowing=true;
        }
        else{
          this.isranklistshowing=false;
          this.checkranklist=false;
        }
      }
    }
  }
</script>

<style type="text/less" lang="less" scoped>
  @import "../assets/style/color";
  @import "../assets/style/config";
  @import "../assets/style/mixin";

  .baidurank-table {
    width: 100%;
    border: none;
    border-top: 1px solid #ccc;
    td, th {
      border: none;
      text-align: left;
      line-height: 26px;
      font-size: 12px;
      font-weight: normal;
      .ellipsis();
      &:nth-child(1) {
        width: 70%;
      }
      &:nth-child(2) {
        width: 30%;
      }
    }
    td {
      &:nth-child(1) {
        color: @theme-color;
      }
    }

    tr{
      &:hover{
        background-color: rgb(240, 238, 238)
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/pages/BaiduRank.vue